import { matchPath, useLocation } from "react-router-dom";

const useMatchPath = (options) => {
  const location = useLocation()
  const match = matchPath(location.pathname, options)
  return !!match
}

export default useMatchPath
